import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Videos from './views/Videos.vue'
import About from './views/About.vue'
import Jerry from './views/Jerry.vue'
import Contact from './views/Contact.vue'
import Routes from './classes/Routes'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/', name: Routes.home, component: Home, children: [
                { path: '/give', name: Routes.give, meta: { showModal: true } }
            ]
        },
        { path: '/sermons', name: Routes.videos, component: Videos, meta: { title: "Sermons" } },
        { path: '/about', name: Routes.about, component: About, meta: { title: "About Us" } },
        { path: '/pastor-jerry', name: Routes.jerry, component: Jerry, meta: { title: "Pastor Jerry" } },
        { path: '/contact-us', name: Routes.contact, component: Contact, meta: { title: "Contact Us" } },
    ]
});

const DEFAULT_TITLE = 'Faith Christian Church Evansville';
router.afterEach((to) => {
    Vue.nextTick(() => {
        document.title = to.meta.title || DEFAULT_TITLE;
    });
});

export default router;